import axiosWrapper from "@AxiosWrapper";
import { getBackendUrl } from "@Utils";
import { revisionSeriesControllerUrl } from "@Services/dataManager";
import type { RevisionSequenceRules, RevisionSequenceType } from "@Helpers/revisionPattern";

export type RevisionSeriesOption = {
  _id: string;
  name?: string;
  isDefault?: boolean;
};

export type RevisionDefaultBehavior = "MANUAL" | "ALWAYS_NEW" | "ALWAYS_PREVIOUS";

type ApiResponse = { status?: boolean; errorMessage?: string };

export const fetchRevisionSeriesList = async (): Promise<RevisionSeriesOption[]> => {
  const response = await axiosWrapper.post<{ result?: RevisionSeriesOption[] }>(revisionSeriesControllerUrl, {});
  return response.data.result ?? [];
};

export const fetchRevisionSeries = async (resourceId: string) => {
  const response = await axiosWrapper.post<
    ApiResponse & {
      result?: {
        revisionSeriesId?: string | null;
        defaultBehavior?: RevisionDefaultBehavior | null;
        startPattern?: string | null;
        sequenceType?: RevisionSequenceType | null;
        sequenceRules?: RevisionSequenceRules | null;
      }[];
    }
  >(`${getBackendUrl()}/folders/getRevisionSeries`, { resourceId });
  const entry = response.data.result?.[0];
  return {
    revisionSeriesId: entry?.revisionSeriesId ?? null,
    defaultBehavior: entry?.defaultBehavior ?? null,
    startPattern: entry?.startPattern ?? null,
    sequenceType: entry?.sequenceType ?? null,
    sequenceRules: entry?.sequenceRules ?? null,
  };
};

export const setRevisionSeries = (data: { resourceId: string; revisionSeriesId: string; cascadeOverride?: boolean }) =>
  axiosWrapper.post<ApiResponse>(`${getBackendUrl()}/folders/setRevisionSeries`, data).then((r) => r.data);
